import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { getApiBaseUrl, LOGIN,ADD_ACTIVITY } from "../../../Config/Config";

const BulkReplaceRetireModal = ({ visible, onClose, selectedIds, onSuccess }) => {
  const modalRef = useRef(null);
  const user = JSON.parse(sessionStorage.getItem("user") || "{}");

  const [status, setStatus] = useState("");
  const [remarks, setRemarks] = useState("");
  const [password, setPassword] = useState("");
  const [askPassword, setAskPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  if (!visible) return null;

  const handleSubmit = () => {
    if (!status || !remarks) {
      Swal.fire("Validation Error", "Please fill all fields", "warning");
      return;
    }
    setAskPassword(true);
  };

const handleConfirm = async () => {
  if (!password) {
    Swal.fire("Password Required", "Please enter password", "warning");
    return;
  }

  const userId = user?.UserID;
  const ids = selectedIds.map((r) => r.Id);
  const Label = selectedIds.map((r) => r.Lable).join(", ");

  if (ids.length === 0) {
    Swal.fire("No Selection", "No filters selected", "warning");
    return;
  }

  setLoading(true);
  let actionSuccess = false;
  let actionLabel = "";

  try {
    const authRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        username: user.UserName,
        password,
      }),
    });

    const authData = await authRes.json();

    if (!authData?.status && authData?.Message !== "Login successful") {
      Swal.fire("Invalid Password", "Authentication failed", "error");
      return;
    }

    let apiUrl = "";
    let payload = {};

    if (status === "105") {
      apiUrl = `${getApiBaseUrl()}/filterph2/filterreplace`;
      payload = {
        id: ids,
        updatedby: userId,
        remarks,
      };
      actionLabel = "Replaced";
    } else if (status === "104") {
      apiUrl = `${getApiBaseUrl()}/filterph2/filterretirement`;
      payload = {
        id: ids,
        Status: 104,
        updatedby: userId,
        remarks,
      };
      actionLabel = "Retired";
    }

    const apiRes = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const apiData = await apiRes.json();

    if (!apiRes.ok) {
      throw new Error(apiData?.Message || "Operation failed");
    }

    actionSuccess = true;

    Swal.fire(
      "Success",
      `Filters ${actionLabel.toLowerCase()} successfully`,
      "success"
    );

    onSuccess();
    onClose();
  } catch (err) {
    console.error(err);
    Swal.fire("Error", err.message || "Something went wrong", "error");
  } finally {
    try {
      await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ActivityType: 1,
          PerformedBy: userId,
          PerformedOn: new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", " "),
          Notes: `Filters ${actionLabel} ${Label}`,
          Location: `Bulk Filter ${actionLabel}`,
          IsSucces: actionSuccess,
        }),
      })
    } catch (logErr) {
      console.error("Activity log failed", logErr);
    }

    setLoading(false);
    setPassword("");
    setAskPassword(false);
  }
};


  const handleClose = () => {
    setAskPassword(false);
    setPassword("");
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) {
      handleClose();
    }
  };

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block", zIndex: 1055 }}
        tabIndex="-1"
        onMouseDown={handleBackdropClick}
      >
        <div className="modal-dialog modal-md modal-dialog-centered">
          <div className="modal-content" ref={modalRef}>
            <div className="modal-header">
              <h5 className="modal-title">Replace / Retire</h5>
              <button
                type="button"
                onClick={handleClose}
                className="btn-close"
                aria-label="Close"
              />
            </div>

            <div className="modal-body">
              {/* STATUS */}
              <div className="mb-3">
                <label className="form-label fw-bold">Select Status</label>
                <div className="d-flex gap-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      value="105"
                      checked={status === "105"}
                      onChange={(e) => setStatus(e.target.value)}
                    />
                    <label className="form-check-label">Replace</label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="status"
                      value="104"
                      checked={status === "104"}
                      onChange={(e) => setStatus(e.target.value)}
                    />
                    <label className="form-check-label">Retire</label>
                  </div>
                </div>
              </div>

              {/* REMARKS */}
              <div className="mb-3">
                <label className="form-label fw-bold">Remarks</label>
                <textarea
                  className="form-control"
                  rows="3"
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                />
              </div>

              {/* PASSWORD */}
              {askPassword && (
                <div className="mb-3">
                  <label className="form-label fw-bold">
                    Confirm Password <span className="text-danger">*</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter Password"
                    />
                    <span
                      className={`ti toggle-password ${
                        showPassword ? "ti-eye" : "ti-eye-off"
                      }`}
                      onClick={() => setShowPassword(!showPassword)}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="modal-footer">
              {!askPassword ? (
                <>
                  <button className="btn btn-secondary" onClick={handleClose}>
                    Close
                  </button>
                  <button className="btn btn-primary" onClick={handleSubmit}>
                    Save
                  </button>
                </>
              ) : (
                <>
                  <button
                    className="btn btn-secondary"
                    onClick={() => {
                      setAskPassword(false);
                      setPassword("");
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={handleConfirm}
                    disabled={loading}
                  >
                    {loading ? "Verifying..." : "Confirm"}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1050 }}
        onClick={handleClose}
      />
    </>
  );
};

BulkReplaceRetireModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
 selectedIds: PropTypes.array.isRequired,
};

export default BulkReplaceRetireModal;
